import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pep',
  templateUrl: './pep.component.html',
  styleUrls: ['./pep.component.scss']
})
export class PepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
